

import { createReducer } from '@reduxjs/toolkit';
import {
    SET_VIDEO_SLIDES, SET_RANDOM_VIDEOS, SET_LAST_PLAYLIST_ID,
} from '../actions/videosSliderActions';

const initialState = {
    videoSlides: [],
    randomVideos: [],
    lastPlaylistId: null,
};

const videosSlider = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_VIDEO_SLIDES, (state, action) => {
            state.videoSlides = action.videoSlides;
        })
        .addCase(SET_RANDOM_VIDEOS, (state, action) => {
            state.randomVideos = action.randomVideos;
        })
        .addCase(SET_LAST_PLAYLIST_ID, (state, action) => {
            state.lastPlaylistId = action.lastPlaylistId;
        });
});

export default videosSlider;
